/**
 * Bridge to the desktop boot splash defined inline in index.html.
 *
 * On the Tauri main window, an inline script shows a branded splash overlay
 * before first paint and exposes `window.__scramblBootSplash.dismiss()`.
 * The app calls `dismissBootSplash()` once the real UI is ready; the splash
 * then crossfades into the app shell (respecting a minimum display time so
 * fast boots never blink). Everywhere else this is a no-op.
 */

interface BootSplashDismissOptions {
  /**
   * Hold the fade-out (up to ~500ms) until the liquid-glass hook has
   * resolved, so the opaque→vibrancy surface switch happens behind the
   * splash instead of visibly popping right after it fades. Pass from the
   * app shell (MainLayout); skip on chrome-less screens like login.
   */
  waitForGlass?: boolean
}

declare global {
  interface Window {
    __scramblBootSplash?: {
      dismiss: (opts?: BootSplashDismissOptions) => void
    }
  }
}

export function dismissBootSplash(opts?: BootSplashDismissOptions): void {
  window.__scramblBootSplash?.dismiss(opts)
}
